var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import { useTranslation } from 'react-i18next';
import { AuthServerFields, AccServerFields, PasswordField, ConfirmPasswordField } from './radius-form-controls';
export function RadiusSettings() {
    var t = useTranslation().t;
    return (_jsxs(Stack, __assign({ direction: "column", gap: 1, "aria-label": t('pages.config_templates.edit.form.auth.auth_setting.scheme.radius.label') }, { children: [_jsx(Divider, {}), _jsx(AuthServerFields, {}), _jsx(AccServerFields, {}), _jsx(Divider, {}), _jsx(PasswordField, {}), _jsx(ConfirmPasswordField, {})] })));
}
